import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import Checkbox from '~/common/components/Checkbox';
import formatCurrency from '~/common/utils/formatCurrency.js';
import { GetRenewalDate } from '~/common/utils/date.js';

// Import Stylesheet
import styles from './renewal-disclaimer.css';

@inject('formsStore', 'convertToPaidStore', 'billingInfoStore')
@observer
export default class RenewalDisclaimer extends Component {
    createMarkup = (markup) => {
        return { __html: markup };
    }

    render() {
        const { formsStore, modifier, total, term } = this.props;
        const { AutoRenewal, AutoRenewalError } = formsStore;

        return (
            <div className={`${styles.wrapper} ${modifier ? styles[`wrapper--${modifier}`] : ''}`}>
                <p className={`${styles.disclaimer} ${modifier ? styles[`disclaimer--${modifier}`] : ''}`}>
                    After the initial term, this recurring subscription of <strong>{formatCurrency(total)}{`/${term}`} {modifier === 'upgrade' ? '' : 'plus applicable taxes & fees'}</strong> will automatically renew until you cancel. The next renewal date is <strong>{GetRenewalDate(term)}</strong>. To prevent renewal, please cancel on or before that date. You can do so by following instructions{' '}
                    <a
                        className={styles.link} href="https://support.grasshopper.com/help/cancel-my-account"
                        target='_blank'
                    >
                        here
                    </a>.
                </p>
                <Checkbox
                    checked={AutoRenewal}
                    checkTheme='green'
                    id="IsAutoRenewal"
                    label='I agree to auto-renewal as described above.'
                    modifier={AutoRenewalError ? styles.error : ''}
                    name="IsAutoRenewal"
                    onChange={() => formsStore.toggleAutoRenewal()}
                />
                {AutoRenewalError && <div className={`${styles['error-message']} ${modifier ? styles[`error-message--${modifier}`] : ''}`} dangerouslySetInnerHTML={this.createMarkup(AutoRenewalError)} />}
            </div>
        );
    }
}
